import { useContext } from "react";
import { AuthContext } from "../utils/contexts";

export default () => useContext(AuthContext);
